import styled from 'styled-components';
import { Divider as DividerAlias } from '@material-ui/core';

export const Divider = styled(DividerAlias)`
  background-color: var(--color-whiteSmoke2);
`;
